export type BadmintonPlayerFormat = 'singles' | 'doubles';
export type BadmintonScoringType = 'rally_21' | 'rally_15' | 'rally_11';
export type BadmintonRotationFormat =
  | 'random_rotation'
  | 'round_robin'
  | 'king_of_the_court';

export interface TambahGameFormState {
  playerFormat: BadmintonPlayerFormat;
  scoringType: BadmintonScoringType;
  maxSets: 1 | 3 | 5;
  numCourts: number;
  rotationFormat: BadmintonRotationFormat | '';
  numRounds: number;
  maxStayWins: number;
  teams: number[][];
}

export interface BadmintonGeneratePayload {
  playerFormat: BadmintonPlayerFormat;
  rotationFormat: BadmintonRotationFormat;
  scoringType: BadmintonScoringType;
  maxSets: 1 | 3 | 5;
  numCourts: number;
  numRounds?: number;
  maxStayWins?: number;
  teams?: number[][];
}

export function createDefaultTambahGameForm(): TambahGameFormState {
  return {
    playerFormat: 'doubles',
    scoringType: 'rally_21',
    maxSets: 3,
    numCourts: 2,
    rotationFormat: '',
    numRounds: 4,
    maxStayWins: 3,
    teams: [],
  };
}

export function previewRandomRotationGames(
  playerCount: number,
  perSide: number,
  gamesPerPlayer: number
): number {
  const need = perSide * 2;
  if (playerCount < need || gamesPerPlayer < 1) return 0;
  const appearances = playerCount * gamesPerPlayer;
  const total = Math.floor(appearances / need);
  return appearances % need === 0 ? total : total + 1;
}

function isTeamComplete(team: number[], perSide: number): boolean {
  if (team.length !== perSide) return false;
  return team.every((id) => id > 0);
}

export function minConfirmedPlayers(playerFormat: BadmintonPlayerFormat): number {
  return playerFormat === 'singles' ? 2 : 4;
}

export function isTambahGameSubmitEnabled(
  form: TambahGameFormState,
  confirmedCount: number
): boolean {
  if (confirmedCount < minConfirmedPlayers(form.playerFormat)) return false;
  if (!form.rotationFormat) return false;
  if (form.rotationFormat !== 'round_robin') return true;
  const perSide = form.playerFormat === 'singles' ? 1 : 2;
  const completeTeams = form.teams.filter((team) => isTeamComplete(team, perSide));
  return completeTeams.length >= 2;
}

export function buildGeneratePayload(form: TambahGameFormState): BadmintonGeneratePayload {
  if (!form.rotationFormat) {
    throw new Error('format rotasi wajib diisi');
  }

  const payload: BadmintonGeneratePayload = {
    playerFormat: form.playerFormat,
    scoringType: form.scoringType,
    maxSets: form.maxSets,
    numCourts: form.numCourts,
    rotationFormat: form.rotationFormat,
  };

  if (form.rotationFormat === 'random_rotation') {
    payload.numRounds = form.numRounds;
  }

  if (form.rotationFormat === 'round_robin') {
    payload.teams = form.teams;
  }

  if (form.rotationFormat === 'king_of_the_court') {
    payload.maxStayWins = form.maxStayWins;
  }

  return payload;
}
